import {
    RowData,
    Table,
    TableFeature,
    Updater,
    functionalUpdate,
    makeStateUpdater,
} from '@tanstack/react-table';
import {
    GivebutterSelectAllRecordsOptions,
    GivebutterSelectAllRecordsTableState,
} from 'types/react-table';

const SelectAllRecordsFeature: TableFeature = {
    getInitialState: (state): GivebutterSelectAllRecordsTableState => ({
        isAllRecordsSelected: false,
        ...state,
    }),

    getDefaultOptions: <TData extends RowData>(
        table: Table<TData>,
    ): GivebutterSelectAllRecordsOptions => ({
        onIsAllRecordsSelectedChange: makeStateUpdater('isAllRecordsSelected', table),
    }),

    createTable: <TData extends RowData>(table: Table<TData>) => {
        table.setIsAllRecordsSelected = updater => {
            const safeUpdater: Updater<boolean> = old => functionalUpdate(updater, old);

            return table.options.onIsAllRecordsSelectedChange?.(safeUpdater);
        };

        table.updateIsAllRecordsSelected = value => {
            table.setIsAllRecordsSelected(!!value);
        };

        table.setOptions({
            ...table.options,
            mergeOptions: (defaultOptions, options) => {
                return {
                    onIsAllRecordsSelectedChange: v => {
                        table.updateIsAllRecordsSelected(v as boolean);
                    },
                    ...defaultOptions,
                    ...options,
                };
            },
        });
    },
};

export { SelectAllRecordsFeature };
